import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';

const StickyMobileContact = () => {
  const openWhatsApp = () => {
    const referenceText = `Reference: ${window.location.href}`;
    const message = encodeURIComponent(`Hi, I have a question about a puja.\n\n${referenceText}`);
    window.open(`https://wa.me/919869929292?text=${message}`, '_blank');
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white/95 backdrop-blur-md border-t border-gray-100 px-4 py-3 pb-[calc(12px+env(safe-area-inset-bottom))] shadow-[0_-8px_30px_rgb(0,0,0,0.08)] animate-slide-in-bottom">
      <div className="flex items-center justify-between gap-4 max-w-lg mx-auto">
        <div className="flex-1 min-w-0">
          <h4 className="text-[13px] font-bold text-BluntRed leading-tight truncate">Have Questions?</h4>
          <p className="text-[10px] text-gray-500 font-medium leading-tight mt-0.5">Reach out to Puja Seva team</p>
        </div>
        
        <div className="flex items-center gap-2 flex-shrink-0">
          {/* Call Button */}
          <button
            onClick={() => window.open('tel:+919869929292', '_self')}
            className="flex items-center justify-center gap-1.5 bg-blue-600 hover:bg-blue-700 active:scale-95 text-white h-9 px-3.5 rounded-full text-[11px] font-bold transition-all duration-200 shadow-sm shadow-blue-200"
          >
            <Phone size={14} fill="currentColor" />
            Call
          </button>

          {/* WhatsApp Button */}
          <button
            onClick={openWhatsApp}
            className="flex items-center justify-center gap-1.5 bg-[#25D366] hover:bg-[#128C7E] active:scale-95 text-white h-9 px-3.5 rounded-full text-[11px] font-bold transition-all duration-200 shadow-sm shadow-green-200"
          >
            <MessageCircle size={14} fill="currentColor" />
            WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyMobileContact;
